import { create } from 'zustand';
import { AccountApi, ApiUtils, RequestEntity, RequestStrategyEnum } from '@shared/api';

interface ICreditLimitRequestsStore {
  loading: boolean;
  error: string | null;
  creditLimitRequests: RequestEntity[] | null;
  getCreditLimitRequests: (accountId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCreditLimitRequestsStore = create<ICreditLimitRequestsStore>((set) => ({
  loading: false,
  error: null,
  creditLimitRequests: null,

  getCreditLimitRequests: ApiUtils.wrapperApi(async (accountId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getCreditLimitRequests(accountId, signal);
      set({ creditLimitRequests: result ?? null, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ creditLimitRequests: null, loading: false, error: null }),
}));
